// Import styles
import './style.scss';

// Import utilities
import * as utilities from '@automator/shared/utils';

// Import i18n
import { sprintf } from '@wordpress/i18n';

/**
 * Export the bare minimum utilities until we can stop using them in addons.
 * @deprecated Use import utilities from '@automator/shared/utils' instead.
 */
window._uo = {
	utility: {
		/**
		 * These 4 are used by: custom-user-fields, restrict-content, user-lists
		 */
		confirm: utilities.confirm.confirm,
		isEmpty: utilities.isEmpty.isEmpty,
		sprintf: sprintf,
		createSnackbar: utilities.createSnackbar.createSnackbar,
	}
};
